import { Link } from 'react-router-dom';
import { latestArticles, categories } from '@/mocks/homeData';

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : '综合';
}

export default function LatestArticles() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              最新资讯文章
            </h2>
            <p className="text-sm text-foreground-600">
              及时了解博彩行业最新动态与专业分析
            </p>
          </div>
          <Link
            to="/category/pingce"
            className="hidden sm:inline-flex items-center text-sm text-accent-600 font-medium hover:text-accent-700 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300/50 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                    {getCategoryName(article.category)}
                  </span>
                </div>
              </div>

              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-accent-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>

                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                  <span className="flex items-center gap-1 text-accent-600 font-medium">
                    阅读 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/pingce"
            className="inline-flex items-center px-6 py-2.5 bg-accent-500 text-background-50 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            查看全部文章 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}